import React from 'react';
import { Box, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useTranslation } from 'react-i18next';

const ClosedMessage = ({ openTime }) => {
  const { t } = useTranslation();
  
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      py: 10,
      px: 2,
      textAlign: 'center',
      minHeight: '50vh'
    }}>
      <AccessTimeIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h5" fontWeight="bold" color="text.primary" gutterBottom>
        {t('common.RestaurantClosed', 'Sorry, We are Closed')}
      </Typography>
      <Typography variant="h6" color="text.secondary">
        {t('common.OpensAt', 'We open at')}
      </Typography>
    </Box>
  );
};

export default ClosedMessage;
